import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-view" }
const _hoisted_2 = { style: {"display":"flex","flex-direction":"column","align-items":"center"} }
const _hoisted_3 = { style: {"margin-bottom":"20px"} }
const _hoisted_4 = { style: {"width":"339px","display":"flex","justify-content":"right","cursor":"pointer"} }
const _hoisted_5 = ["onClick"]

import {computed, defineComponent, Ref, ref, unref} from "vue";
import {UIHandleGet} from "@/views/utils";
import UserAPI from "@/api/UserAPI";
import {setAccessToken} from "@/store";
import {useRouter} from "vue-router";
import {store, loginViewShow} from "@/store";
import {FormInstance, FormRules} from "element-plus";
import {Close} from "@element-plus/icons-vue";


export type Form = {
  loginName: string,
  // 密码登录需要
  password: string,
  // 验证码登录需要
  code: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  props: {
  redirect: {
    type: String,
    required: false
  }
},
  setup(__props) {

const props = __props




const {redirect = "/"} = props
let form = ref<Form>({
  loginName: "",
  password: "",
  code: ""
})
const formEle = ref<FormInstance | null>(null)

// 规则
const rules = computed(() => {

  let rules: FormRules = {
    loginName: {
      required: true,
      message: "电话没有填写",
      trigger: "blur"
    },
    password: {
      required: true,
      message: "密码没有填写",
      trigger: "blur"
    }
  }

  return rules
})

const {login, loading} = useLogin(form, redirect)
const router = useRouter()
const goGetBackPasswordView = () => {
  loginViewShow.value = false
  router.push({
    name: "GetBackPassword"
  })
}
function useLogin(formRef: Ref<Form>, redirect: string) {
  const loading = ref(false)
  const login = async () => {

    await formEle.value!.validate()

    try {
      loading.value = true
      let form = unref(formRef)

      let result: any

      let data: any = {
        tel: form.loginName,
        password: form.password
      }
      result = await UIHandleGet(UserAPI.loginByTelAndPassword(data))

      setAccessToken(result.accessToken, result.id)
      location.reload()

    } catch (e) {
      console.error(e)
    } finally {
      loading.value = false
    }
  }

  return {
    login,
    loading
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          "validate-on-rule-change": false,
          ref_key: "formEle",
          ref: formEle,
          rules: _unref(rules),
          model: _unref(form),
          "label-width": "0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { prop: "loginName" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"339px","height":"45px"},
                  placeholder: "请输入手机号",
                  modelValue: _unref(form).loginName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).loginName) = $event)),
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "password" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "请输入密码",
                  style: {"width":"339px","height":"45px"},
                  autocomplete: "new-password",
                  modelValue: _unref(form).password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).password) = $event)),
                  "show-password": "",
                  size: "large"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", {
                    onClick: _withModifiers(goGetBackPasswordView, ["stop"]),
                    class: "forget-password-text font-assistant primary-text"
                  }, "忘记/修改密码", 8, _hoisted_5)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          style: {"width":"339px","height":"45px"},
          loading: _unref(loading),
          onClick: _unref(login),
          type: "danger"
        }, {
          default: _withCtx(() => [
            _createTextVNode("登录 ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ])
  ]))
}
}

})